import React from "react"
import classes from "./ResultSet.module.css"
import useCollapse from "react-collapsed"
import { get_roll, advanceFrame } from "../SeedChecker/SeedCalculator"
import { SkillIDsRev } from "../../Utils"
import { useTranslation, Trans } from "react-i18next"

const ResultSetSearch = props => {
    const { t } = useTranslation()
    const { getCollapseProps, getToggleProps, isExpanded } = useCollapse()

    const format_res = (r, r2, r3) => {
        if (r3 === "Unknown") {
            if (r === "None") {
                return (
                    <li>
                        <Trans
                            i18nKey="misc:Checker.SearchResultUnlockSlot"
                            defaults="Unlock a slot with NO drink active to unlock <0 />"
                            components={[
                                <img
                                    src={`https://leanny.github.io/splat3/images/skill/${r2}.png`}
                                    alt={r[1]}
                                    className={classes.Ability}
                                    width={32}
                                />,
                            ]}
                        />
                    </li>
                )
            } else {
                return (
                    <li>
                        <Trans
                            i18nKey="misc:Checker.SearchResultUnlockSlotDrink"
                            defaults="Unlock a slot with <0 /> drink active to unlock <1 />"
                            components={[
                                <img
                                    src={`https://leanny.github.io/splat3/images/skill/${r}.png`}
                                    alt={r}
                                    className={classes.Ability}
                                    width={32}
                                />,
                                <img
                                    src={`https://leanny.github.io/splat3/images/skill/${r2}.png`}
                                    alt={r2}
                                    className={classes.Ability}
                                    width={32}
                                />,
                            ]}
                        />
                    </li>
                )
            }
        } else {
            if (r === "Unknown") {
                return (
                    <li>
                        <Trans
                            i18nKey="misc:Checker.SearchResultChunks"
                            defaults="Unlock a slot with <0></0> chunks."
                            components={[
                                <img
                                    src={`https://leanny.github.io/splat3/images/skill/${r3}.png`}
                                    alt={r3}
                                    className={classes.Ability}
                                    width={32}
                                />,
                            ]}
                        />
                    </li>
                )
            } else {
                if (r === "None") {
                    return (
                        <>
                            <li>
                                <Trans
                                    i18nKey="misc:Checker.SearchResultUnlockSlot"
                                    defaults="Unlock a slot with NO drink active to unlock <0 />"
                                    components={[
                                        <img
                                            src={`https://leanny.github.io/splat3/images/skill/${r2}.png`}
                                            alt={r[1]}
                                            className={classes.Ability}
                                            width={32}
                                        />,
                                    ]}
                                />
                            </li>
                            <li>
                                <Trans
                                    i18nKey="misc:Checker.ReplaceWithChunks"
                                    defaults="Replace <0 /> with <1 /> chunks."
                                    components={[
                                        <img
                                            src={`https://leanny.github.io/splat3/images/skill/${r2}.png`}
                                            alt={r2}
                                            className={classes.Ability}
                                            width={32}
                                        />,
                                        <img
                                            src={`https://leanny.github.io/splat3/images/skill/${r3}.png`}
                                            alt={r3}
                                            className={classes.Ability}
                                            width={32}
                                        />,
                                    ]}
                                />
                            </li>
                        </>
                    )
                } else {
                    return (
                        <>
                            <li>
                                <Trans
                                    i18nKey="misc:Checker.SearchResultUnlockSlotDrink"
                                    defaults="Unlock a slot with <0 /> drink active to unlock <1 />"
                                    components={[
                                        <img
                                            src={`https://leanny.github.io/splat3/images/skill/${r}.png`}
                                            alt={r}
                                            className={classes.Ability}
                                            width={32}
                                        />,
                                        <img
                                            src={`https://leanny.github.io/splat3/images/skill/${r2}.png`}
                                            alt={r2}
                                            className={classes.Ability}
                                            width={32}
                                        />,
                                    ]}
                                />
                            </li>
                            <li>
                                <Trans
                                    i18nKey="misc:Checker.ReplaceWithChunks"
                                    defaults="Replace <0 /> with <1 /> chunks."
                                    components={[
                                        <img
                                            src={`https://leanny.github.io/splat3/images/skill/${r2}.png`}
                                            alt={r2}
                                            className={classes.Ability}
                                            width={32}
                                        />,
                                        <img
                                            src={`https://leanny.github.io/splat3/images/skill/${r3}.png`}
                                            alt={r3}
                                            className={classes.Ability}
                                            width={32}
                                        />,
                                    ]}
                                />
                            </li>
                        </>
                    )
                }
            }
        }
    }

    const get_shortest_advances = (start_seed, end_seed, brand) => {
        const limit = advanceFrame(end_seed >>> 0, 1) >>> 0
        const all_paths = []
        let current_seed = start_seed
        const drink_use = SkillIDsRev[0]
        for (let i = 0; current_seed !== end_seed && current_seed !== limit; i++) {
            const curr = []
            for (let k = 0; k < i; k++) {
                curr.push("None")
            }
            current_seed = advanceFrame(start_seed, i) >>> 0
            while (current_seed !== end_seed && current_seed !== limit) {
                curr.push("Drink")
                const [res, ,] = get_roll(current_seed, brand, drink_use)
                if (res === 0) return []
                current_seed = res >>> 0
            }
            if (current_seed === end_seed) {
                all_paths.push(curr)
            }
            current_seed = advanceFrame(start_seed, i) >>> 0
        }
        for (let i = 0; current_seed !== end_seed && current_seed !== limit; i++) {
            const curr = []
            current_seed = advanceFrame(start_seed, i) >>> 0
            for (let k = 0; k < i; k++) {
                curr.push("Drink")
                const [res, ,] = get_roll(current_seed, brand, drink_use)
                if (res === 0) return []
                current_seed = res >>> 0
            }
            while (current_seed !== end_seed && current_seed !== limit) {
                curr.push("None")
                current_seed = advanceFrame(current_seed, 1) >>> 0
                if (current_seed === 0) return []
            }
            if (current_seed === end_seed) {
                all_paths.push(curr)
            }
            current_seed = advanceFrame(start_seed, i) >>> 0
        }
        return all_paths.reduce(
            function (p, c) {
                return p.length > c.length ? c : p
            },
            { length: Infinity }
        )
    }

    const format_shortest_path = (start_seed, drink, brand, path) => {
        const res = []
        let current_seed = start_seed >>> 0
        const use_drink = drink === "None" || drink === "Unknown" ? SkillIDsRev[0] : drink
        let i = 0
        for (const elem of path) {
            if (elem === "None") {
                const [current_seed_res, ability_rolled] = get_roll(current_seed, brand, "None")
                current_seed = current_seed_res
                res.push(
                    <li key={i}>
                        <Trans
                            i18nKey="misc:Checker.SearchResultUnlockSlot"
                            defaults="Unlock a slot with NO drink active to unlock <0></0>"
                            components={[
                                <img
                                    src={`https://leanny.github.io/splat3/images/skill/${ability_rolled}.png`}
                                    alt={ability_rolled}
                                    className={classes.Ability}
                                    width={32}
                                />,
                            ]}
                        />
                        ({t("misc:Checker.SearchResultResultingSeed")}: 0x{(current_seed >>> 0).toString(16)}, +1{" "}
                        {t("misc:Checker.Advances")}).
                    </li>
                )
            } else {
                const [current_seed_res, ability_rolled] = get_roll(current_seed, brand, use_drink)
                current_seed = current_seed_res
                res.push(
                    <li key={i}>
                        <Trans
                            i18nKey="misc:Checker.SearchResultUnlockSlotDrink"
                            defaults="Unlock a slot with <0></0> drink active to unlock <1></1>"
                            components={[
                                <img
                                    src={`https://leanny.github.io/splat3/images/skill/${use_drink}.png`}
                                    alt={use_drink}
                                    className={classes.Ability}
                                    width={32}
                                />,
                                <img
                                    src={`https://leanny.github.io/splat3/images/skill/${ability_rolled}.png`}
                                    alt={ability_rolled}
                                    className={classes.Ability}
                                    width={32}
                                />,
                            ]}
                        />
                        ({t("misc:Checker.SearchResultResultingSeed")}: 0x{(current_seed >>> 0).toString(16)}, +
                        {use_drink === ability_rolled ? 1 : 2} {t("misc:Checker.Advances")}).
                    </li>
                )
            }
            i += 1
        }
        return res
    }

    const efficient_collapse = (start_seed, end_seed, drink, brand) => {
        const shortest_path = get_shortest_advances(start_seed, end_seed, brand)
        return (
            <>
                <p>{t("misc:Checker.SearchResultNote")}</p>
                <ol>{format_shortest_path(start_seed >>> 0, drink, brand, shortest_path)}</ol>
            </>
        )
    }

    if (props.results.length === 0) {
        return <div className={classes.WrapperNoScroll}>{t("misc:Checker.ResultNoResults")}</div>
    }
    if (props.results[0].length === 1) {
        return <div className={classes.WrapperNoScroll}>{t("misc:Checker.ResultNoResultsFound")}</div>
    }
    const all_res = props.results.map((arr, idx) => {
        const seed = arr[0]
        const res = arr[1]
        const advances = arr[2]

        return (
            <div key={idx}>
                {t("misc:Checker.SearchResultPathFound")}
                <ol>
                    <li>
                        <p>
                            {
                                //`Advance your seed ${advances} times and start at seed 0x${(seed >>> 0).toString(16)}`
                            }
                            {t("misc:Checker.SearchResultAdvanceSeed", {
                                advances: advances,
                                seed: "0x" + (seed >>> 0).toString(16),
                            })}
                        </p>
                        {advances === 0 ? null : (
                            <>
                                <button {...getToggleProps()}>
                                    {isExpanded
                                        ? t("misc:Checker.SearchResultHideHowToAdvance")
                                        : t("misc:Checker.SearchResultShowHowToAdvance")}
                                </button>
                                <section {...getCollapseProps()}>
                                    {efficient_collapse(
                                        props.currentSeed >>> 0,
                                        seed >>> 0,
                                        res[0][0] !== "Unknown" && res[0][0] !== "None"
                                            ? res[0][0]
                                            : res[0][1] !== "Unknown" && res[0][0] !== "None"
                                            ? res[0][1]
                                            : res[0][2] !== "None"
                                            ? res[0][2]
                                            : "Unknown",
                                        props.currentBrand
                                    )}
                                </section>
                            </>
                        )}
                    </li>

                    {!res[2][0] || (res[1][0] === "Unknown" && res[2][0] === "Unknown")
                        ? null
                        : format_res(res[0][0], res[1][0], res[2][0])}
                    {!res[2][1] || (res[1][1] === "Unknown" && res[2][1] === "Unknown")
                        ? null
                        : format_res(res[0][1], res[1][1], res[2][1])}
                    {!res[2][2] || (res[1][2] === "Unknown" && res[2][2] === "Unknown")
                        ? null
                        : format_res(res[0][2], res[1][2], res[2][2])}
                </ol>
            </div>
        )
    })
    return <div className={classes.WrapperNoScroll}>{all_res}</div>
}

export default React.memo(ResultSetSearch)
